import "bootstrap/dist/css/bootstrap.min.css";
import 'react-confirm-alert/src/react-confirm-alert.css';
import 'react-toastify/dist/ReactToastify.css';
import "bootstrap/dist/js/bootstrap.bundle";
import "react-datepicker/dist/react-datepicker.css";
import 'font-awesome/css/font-awesome.min.css';
import 'react-dropzone-uploader/dist/styles.css'
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import '@availity/block-ui/dist/index.css';
import 'loaders.css/loaders.min.css';
import "./styles/App.css";
import "./styles/skin.css";
import '@szhsin/react-menu/dist/index.css';
import '@szhsin/react-menu/dist/transitions/slide.css';
// import 'react-dates/lib/css/_datepicker.css';
import 'tippy.js/dist/tippy.css';
import 'rc-slider/assets/index.css';
import 'pace-js'
import 'pace-js/themes/blue/pace-theme-minimal.css'
import "react-day-picker/style.css";


import React, { useEffect, useLayoutEffect, useState, useRef } from "react";
import { useIdleTimer } from 'react-idle-timer'
import { useTranslation } from 'react-i18next';
import { getCurrentUser, logout } from './util/AuthUtils';
import { useNavigate, useLocation } from 'react-router-dom'
import MainRouter from './components/main-router'
import useStore from "./hooks/useStore";
import useLocalStorage from './hooks/useLocalStorage'
import Commons from "./util/commons";

const IDLE_TIMEOUT = 1000 * 60 * 15;
const PROMPT_BEFORE_IDLE = 1000 * 60;

export default function App() {

  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();

  const PUBLIC_PATHS = ['/login', '/register', '/forgot', '/oauth2/redirect'];
  const isPublicPage = PUBLIC_PATHS.some(p => location.pathname.startsWith(p)) || location.pathname.startsWith('/reset/');

  const setLoggedInUser = useStore((state) => state.setLoggedInUser);
  const setSelectedCompany = useStore((state) => state.setSelectedCompany);
  const setBootstrapped = useStore((state) => state.setBootstrapped);

  const [company, saveCompany, removeCompany] = useLocalStorage("company", null);
  const [user, saveUser, removeUser] = useLocalStorage("user", null);

  const [showIdleWarning, setShowIdleWarning] = useState(false);
  const [remaining, setRemaining] = useState(PROMPT_BEFORE_IDLE / 1000);
  const countdownRef = useRef(null);

  const stopCountdown = () => {
    if (countdownRef.current) {
      clearInterval(countdownRef.current);
      countdownRef.current = null;
    }
  };

  const handleOnPrompt = () => {
    if (isPublicPage) return;
    setShowIdleWarning(true);
    setRemaining(PROMPT_BEFORE_IDLE / 1000);
    countdownRef.current = setInterval(() => {
      setRemaining(prev => Math.max(0, prev - 1));
    }, 1000);
  };

  const handleOnIdle = () => {
    stopCountdown();
    setShowIdleWarning(false);
    if (isPublicPage) return;
    logout();
    navigate("/login");
  };

  const handleContinue = () => {
    stopCountdown();
    setShowIdleWarning(false);
    activate();
  };

  const { getRemainingTime, activate } = useIdleTimer({
    timeout: IDLE_TIMEOUT,
    promptBeforeIdle: PROMPT_BEFORE_IDLE,
    onPrompt: handleOnPrompt,
    onIdle: handleOnIdle,
    debounce: 500,
    crossTab: true
  });

  function syncUserOnLocalStorage() {
    getCurrentUser()
      .then(response => {
        if (response == undefined) {
          removeUser();
        }
        else {
          saveUser(response.user);
          setLoggedInUser(response.user);
          if (response.companies && response.companies.length > 0) {
            if (response.companies && response.companies.length == 1) {
              saveCompany(response.companies[0]);
              setSelectedCompany(response.companies[0]);
            }
            else if (company) {
              const ids = response.companies.map(item => item.id);
              if (ids.includes(company.id)) {
                const _company = response.companies.find(comp => comp.id === company.id);
                saveCompany(_company);
                setSelectedCompany(_company);
              }
              else {
                removeCompany();
                Commons.setDefault("branch", undefined);
                Commons.setDefault("invoiceType", undefined);
                Commons.setDefault("series", undefined);
              }
            }
          }
        }
      }).catch(error => {
        removeUser();
        navigate("/login");
      });
  }


  useLayoutEffect(() => {
    setSelectedCompany(company);
    setLoggedInUser(user);
    setBootstrapped(true);
  }, []);

  useEffect(() => {
    syncUserOnLocalStorage();
  }, []);


  return (
    <div className="App Fade">
      <MainRouter />
      {showIdleWarning && (
        <>
          <div className="modal-backdrop fade show" />
          <div className="modal fade show d-block" tabIndex="-1" role="dialog">
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">
                    <i className="fa fa-clock-o me-2" />
                    {t("sessionExpiringTitle")}
                  </h5>
                </div>
                <div className="modal-body text-center py-4">
                  <p className="mb-1">{t("sessionExpiringMessage")}</p>
                  <p className="display-6 fw-bold text-danger">{remaining}</p>
                  <p className="mb-0 text-muted">{t("sessionExpiringSeconds")}</p>
                </div>
                <div className="modal-footer justify-content-center">
                  <button className="btn btn-skin px-4" onClick={handleContinue}>
                    {t("continueSession")}
                  </button>
                  <button className="btn btn-outline-secondary px-4" onClick={handleOnIdle}>
                    {t("Logout")}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
}
